import { useState } from 'react'
import { useSearch } from 'features/search/context'
import { SisetuResult } from 'interface/sisetu'

import { Stack, Box, useTheme, useMediaQuery, Divider, Button, Slide, Paper } from "@mui/material"
import {
  Comment as CommentIcon
} from '@mui/icons-material'

import { SisetuScoreRadar } from "./components/scoreRadar"
import { SisetuSummary, useSisetuSummary } from "./components/sisetuSummary"
import { SisetuBlock, useOyaDaigaku, useChildrenSisetu } from "./components/sisetuBlock"
import { SisetuGuideLines } from "./components/sisetuGuideLines"
import { SisetuCommentBlock } from "./components/sisetuCommentBlock"
import { BlockCaption } from 'components/controls/blockCaption'
import { useSisetuPreview } from '../../container'
import { useResizeDetector } from 'react-resize-detector';
import { Loading } from 'components/controls/loading'

type SisetuPreviewBasicPageProps = {
  sisetu: SisetuResult
  container: ReturnType<typeof useSisetuPreview>
}
export const SisetuPreviewBasicPage = ({
  sisetu,
  container: {
    onSisetuOpen,
    onKojinOpen
  }
}: SisetuPreviewBasicPageProps) => {
  const theme = useTheme()
  const isMiddleMedia = useMediaQuery(theme.breakpoints.down('lg'))
  const isSmallMedia = useMediaQuery(theme.breakpoints.down('sm'))
  
  const { width: scoreRaderWidth, ref: refScoreRader } = useResizeDetector()

  const [isShowComment, setShowComment] = useState<boolean>(false)

  const search = useSearch()
  
  const sectionWidth = isSmallMedia ? '5rem' : undefined

  const oyaDaigaku = useOyaDaigaku(sisetu)
  const childrenSisetu = useChildrenSisetu(sisetu)
  const summary = useSisetuSummary(sisetu)
  return (
    <>
      { summary.loading && <Loading/> }

      <Stack
        direction="row"
        overflow="hidden"
        width="100%"
        height="100%"
        boxSizing="border-box"
      >
        <Stack
          flexGrow={1}
          direction="column"
          spacing={1}
          overflow="auto"
          height="100%"
          boxSizing="border-box"
        >
          {sisetu.score ? (
            <Box>
              <BlockCaption caption="分析結果"/>
              <Box
                ref={refScoreRader}
                sx={isSmallMedia ? undefined : {
                  width: '40%',
                  maxWidth: '340px',
                  minWidth: '300px'
                }}
              >
                <SisetuScoreRadar sisetu={sisetu} width={scoreRaderWidth} height={220}/>
              </Box>
              <SisetuGuideLines sisetu={sisetu} labelWidth={sectionWidth}/>
            </Box>
          ) : <></>}

          <SisetuBlock
            sisetu={sisetu}
            oyaDaigaku={oyaDaigaku}
            childrenSisetu={childrenSisetu}
            isSmallMedia={isSmallMedia}
            sectionWidth={sectionWidth}
            onSisetuOpen={onSisetuOpen}
          />

          {summary.isValid && (
            <SisetuSummary
              summary={summary}
              position="relative"
              onKojinOpen={onKojinOpen}
            />
          )}

          {(search && isMiddleMedia === true) && (
            <>
              <Box height="3rem" flexShrink={0}/>
              <Box
                position="absolute"
                right={0}
                bottom={0}
                padding={2}
                zIndex={10}
              >
                <Button
                  size="large"
                  variant="contained"
                  startIcon={<CommentIcon/>}
                  onClick={() => setShowComment(true)}
                >
                  コメント
                </Button>
              </Box>
            </>
          )}
        </Stack>

        {(search && isMiddleMedia === false) && (
          <>
            <Divider orientation="vertical"/>
            <SisetuCommentBlock
              sisetu={sisetu}
              width="30%"
              minWidth="20rem"
              flexShrink={0}
            />
          </>
        )}
      </Stack>

      {(search && isMiddleMedia) ? (
        <Slide
          direction="left"
          in={isShowComment}
          mountOnEnter unmountOnExit
        >
          <Paper
            square
            elevation={4}
            sx={{
              position: "absolute",
              right: 0,
              width: "25rem",
              maxWidth: "80%",
              top: 0,
              bottom: 0,
              zIndex: 99
            }}
          >
            <SisetuCommentBlock
              sisetu={sisetu}
              flexShrink={0}
              onClose={() => setShowComment(false)}
            />
          </Paper>
        </Slide>
      ) : <></>}
    </>
 )
}